// 活动报名
import Log from '../view/log'
import ActivityNav from '../view/Activity/ActivityNav'
import ActivityManage from '../view/Activity/ActivityManage/ActivityManage'
import ActivityAdd from '../view/Activity/ActivityManage/ActivityAdd'
import ActivityModify from '../view/Activity/ActivityManage/ActivityModify'
import RegistrationRecord from '../view/Activity/RegistrationRecord/RegistrationRecord'
import EventStatistics from '../view/Activity/EventStatistics/EventStatistics'
import ActivityConsumptionRecord from '../view/Activity/ConsumptionRecord/ActivityConsumptionRecord'

export default [
  /* 报名 */
  {
    path: '/activity_manage',
    name: 'activity-manage',
    components: {
      default: ActivityNav,
      a: ActivityManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/activity_add',
    name: 'activity-add',
    components: {
      default: ActivityNav,
      a: ActivityAdd
    }
  },
  {
    path: '/activity_modify/:id',
    name: 'activity-modify',
    components: {
      default: ActivityNav,
      a: ActivityModify
    }
  },
  {
    path: '/registration_record',
    name: 'registration-record',
    components: {
      default: ActivityNav,
      a: RegistrationRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/event_statistics',
    name: 'event-statistics',
    components: {
      default: ActivityNav,
      a: EventStatistics
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/activity_consumption_record',
    name: 'activity-consumption-record',
    components: {
      default: ActivityNav,
      a: ActivityConsumptionRecord
    },
    meta: {
      keepAlive: true
    }
  },
  // 智慧活动操作日志
  {
    path: '/activity_log',
    name: 'activity-log',
    components: {
      default: ActivityNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/Activity.js